import React from "react";
import { PlayerHeaderView } from "../views/PlayerHeaderView";

// "Players" header cell. Counts are computed in StatusTrackerGrid (over the filtered rows) and
// passed in via `columns`, so the header re-renders whenever filters change.
export const PlayerColumnHeader = ({ counts = [] }) => <PlayerHeaderView counts={counts} />;
